import { defineMessages } from 'react-intl';

export default defineMessages({
  devStatusCommits: {
    id: 'frontbucket.dashboard.overview.jiraIssues.devStatusCommits',
    description:
      'Tooltip label for dev status commits information for Jira issues on dashboard',
    defaultMessage:
      '{count, plural, one {{count} commit} other {{count} commits}}',
  },
  devStatusPullRequests: {
    id: 'frontbucket.dashboard.overview.jiraIssues.devStatusPullRequests',
    description:
      'Tooltip label for dev status pull requests information for Jira issues on dashboard',
    defaultMessage:
      '{count, plural, one {{count} pull request} other {{count} pull requests}}',
  },
  devStatusMergedPullRequests: {
    id: 'frontbucket.dashboard.overview.jiraIssues.devStatusMergedPullRequests',
    description:
      'Tooltip label for dev status merged pull requests information for Jira issues on dashboard',
    defaultMessage:
      '{count, plural, one {{count} merged pull request} other {{count} merged pull requests}}',
  },
  devStatusDeclinedPullRequests: {
    id: 'frontbucket.dashboard.overview.jiraIssues.devStatusDeclinedPullRequests',
    description:
      'Tooltip label for dev status declined pull requests information for Jira issues on dashboard',
    defaultMessage:
      '{count, plural, one {{count} declined pull request} other {{count} declined pull requests}}',
  },
  devStatusOpenBranches: {
    id: 'frontbucket.dashboard.overview.jiraIssues.devStatusOpenBranches',
    description:
      'Tooltip label for dev status open branches information for Jira issues on dashboard',
    defaultMessage:
      '{count, plural, one {{count} branch} other {{count} branches}}',
  },
  devStatusDeployments: {
    id: 'frontbucket.dashboard.overview.jiraIssues.devStatusDeployments',
    description:
      'Tooltip label for dev status deployments information for Jira issues on dashboard',
    defaultMessage:
      '{count, plural, one {{count} deployment} other {{count} deployments}}',
  },
});
